function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 10.995V14.5a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-7a.5.5 0 01.146-.354l6-6a.5.5 0 01.708 0l6 6a.5.5 0 01.146.354v7a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5V11c0-.25-.25-.5-.5-.5H7c-.25 0-.5.25-.5.495z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 2.5V6l-2-2V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z",
  clipRule: "evenodd"
});

function SvgHome(props) {
  return React.createElement("svg", _extends({
    className: "home_svg__bi home_svg__bi-house-door-fill",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktaG91c2UtZG9vci1maWxsIiB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTYuNSAxMC45OTVWMTQuNWEuNS41IDAgMDEtLjUuNUgyYS41LjUgMCAwMS0uNS0uNXYtN2EuNS41IDAgMDEuMTQ2LS4zNTRsNi02YS41LjUgMCAwMS43MDggMGw2IDZhLjUuNSAwIDAxLjE0Ni4zNTR2N2EuNS41IDAgMDEtLjUuNWgtNGEuNS41IDAgMDEtLjUtLjVWMTFjMC0uMjUtLjI1LS41LS41LS41SDdjLS4yNSAwLS41LjI1LS41LjQ5NXoiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyAyLjVWNmwtMi0yVjIuNWEuNS41IDAgMDEuNS0uNWgxYS41LjUgMCAwMS41LjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgHome as ReactComponent };